import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../theme/modern/tokens"

export default makeStyles((theme: ModernTheme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: theme.modern.bg,
        color: theme.modern.ink,
        fontFamily: theme.modern.sans,
        fontSize: 13,
        lineHeight: 1.5,
    },
}))
